/**
 * 栽培区分
 */
export const CaltivationCategoryConst = 
{
  /**
   * 慣行
   */
  CONVENTIONAL: 1,
  /**
   * JAS有機
   */
  JASORGANIC: 2,
} as const;
export type  CaltivationCategoryType = typeof CaltivationCategoryConst[keyof typeof CaltivationCategoryConst];

export const CaltivationCategoryOptions: {value: CaltivationCategoryType; label: string; color: string }[] = [
  {value: CaltivationCategoryConst.CONVENTIONAL, label: '慣行', color:  'bg-gray-100 text-gray-800' },
  {value: CaltivationCategoryConst.JASORGANIC, label: 'JAS有機', color:  'bg-gray-100 text-gray-800' },
];